import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export type RemoveGroupMemberVariables = { id: number };

export async function removeGroupMemberFn(
  axiosInstance: Promise<AxiosInstance>,
  { id }: RemoveGroupMemberVariables,
) {
  const instance = await axiosInstance;
  return instance.delete(`/group/members/${id}`);
}

export function useRemoveGroupMember() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, RemoveGroupMemberVariables>({
    mutationFn: variables => removeGroupMemberFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['groupMembers'] });
      client.invalidateQueries({ queryKey: ['groupCandidates'] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    RemoveGroupMemberVariables,
    'removeGroupMember'
  >('removeGroupMember', mutation);
}
